import { render, staticRenderFns } from "./CMBPastDueCompanyNotification.vue?vue&type=template&id=26748844&"
import script from "./CMBPastDueCompanyNotification.vue?vue&type=script&lang=js&"
export * from "./CMBPastDueCompanyNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports